import type { Outcome } from '../state/Store';
import type { SpotId } from '../world/layout';

export interface Blackout {
  spot: SpotId;
  outcome: Outcome;
}

/** Where you wake up after passing out, and what it cost you. */
export const BLACKOUTS: readonly Blackout[] = [
  {
    spot: 'junkyardDrop',
    outcome: {
      text: 'You woke up in the junkyard, inside a 1994 Buick. Honestly? Comfy. Great lumbar support.',
    },
  },
  {
    spot: 'tankHouse',
    outcome: {
      text: 'You woke up spooning Tank outside his doghouse. He seems fine with it. Good boy.',
      clout: 2,
    },
  },
  {
    spot: 'gasCanopy',
    outcome: {
      text: "You woke up under the Gas-N-Grub canopy holding a hot dog you don't remember buying. You eat it. No questions.",
      stats: { hunger: 30 },
    },
  },
  {
    spot: 'laundromatDoor',
    outcome: { text: 'You woke up inside a dryer at Suds-N-Duds. Fluff cycle. You feel... soft. Renewed.' },
  },
  {
    spot: 'earlFirePit',
    outcome: {
      text: "You woke up in Earl's lawn chair wearing his NASCAR jacket. Earl says keep it. Earl is lying.",
      clout: 2,
    },
  },
  {
    spot: 'bigDaveHome',
    outcome: {
      text: "You woke up on the porch of Big Dave's display double-wide. You've never felt so close to your dreams.",
    },
  },
  {
    spot: 'waterTower',
    outcome: {
      text: 'You woke up at the base of the water tower holding spray paint. Your name is up there now. Spelled wrong.',
      clout: 5,
    },
  },
];
